import React from "react";
import { Smartphone, Wifi, Phone, MessageSquare, CheckCircle2 } from "lucide-react";

/**
 * Travel-pack eSIM opt-in card. Used in checkout (regular + external booking).
 * Controlled by parent: `checked` + `onToggle`.
 *
 * For Phase 1 the pack is **free** with every booking — copy reflects that.
 */
export default function TravelPackToggle({ checked, onToggle, testid = "travel-pack", disabled = false }) {
  return (
    <label
      className={"zc-card p-5 block transition relative " + (disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer ") + (checked && !disabled ? "ring-2" : !disabled ? "hover:border-[var(--zc-text-3)]" : "")}
      style={checked && !disabled ? { boxShadow: "0 0 0 2px var(--zc-secondary)" } : {}}
      data-testid={testid}
    >
      <div className="flex items-start gap-4">
        <div className="w-11 h-11 grid place-items-center rounded-xl text-white shrink-0" style={{ background: "var(--zc-secondary)" }}>
          <Smartphone size={20} />
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 flex-wrap">
            <div className="zc-title text-lg leading-tight">Z-Cars Travel Pack</div>
            <span className="zc-badge px-1.5 py-0.5 text-white" style={{ background: "var(--zc-accent)" }}>
              Free
            </span>
          </div>
          <p className="text-xs text-[var(--zc-text-2)] mt-1 leading-relaxed">
            Land connected. Bundled eSIM with{" "}
            <b className="text-[var(--zc-text)]">1&nbsp;GB data</b>,{" "}
            <b className="text-[var(--zc-text)]">100&nbsp;voice mins</b>,{" "}
            <b className="text-[var(--zc-text)]">100&nbsp;SMS</b>. Scannable QR
            arrives the moment your booking is confirmed.
          </p>
          <div className="flex flex-wrap gap-3 mt-3 zc-hint">
            <span className="flex items-center gap-1"><Wifi size={11} /> 1 GB</span>
            <span className="flex items-center gap-1"><Phone size={11} /> 100 min</span>
            <span className="flex items-center gap-1"><MessageSquare size={11} /> 100 SMS</span>
            <span>30-day validity · 170+ countries</span>
          </div>
        </div>
        <div className="shrink-0">
          <input
            type="checkbox"
            checked={!!checked}
            disabled={disabled}
            onChange={(e) => !disabled && onToggle?.(e.target.checked)}
            className="sr-only"
            data-testid={`${testid}-input`}
          />
          <div
            className="w-6 h-6 rounded-full grid place-items-center transition"
            style={checked
              ? { background: "var(--zc-secondary)", color: "white" }
              : { background: "var(--zc-bg-3)", border: "1px solid var(--zc-border-2)" }}
            aria-label={checked ? "Selected" : "Not selected"}
          >
            {checked && <CheckCircle2 size={14} />}
          </div>
        </div>
      </div>
    </label>
  );
}
